import { render } from "./SearchIconMuted.vue?vue&type=template&id=1562fe66"
import script from "./SearchIconMuted.vue?vue&type=script&lang=js"
export * from "./SearchIconMuted.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects 2022\\helmets-nepal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__